import { applyPolyfills, defineCustomElements } from '@tokenyico/design-system/loader';
import * as ds from '@tokenyico/design-system';
import dsComponent from './ds';

export default {
  install: async (Vue) => {
    // vuejs: ignore html elements starting with ds-
    Vue.config.ignoredElements = [/ds-\w*/];

    // Attach all utility functions to Vue prototype so it's available everywhere
    Vue.prototype.ds = ds;

    // Shim component to map dsInput event to value.sync listener
    Vue.component('ds', dsComponent);

    // Load polyfills and custom elements
    await applyPolyfills()
    defineCustomElements();
  }
};
